export const WIRE_FILE_UPLOAD_WORKFLOW_CONTAINER_TAG_NAME = 'wire-file-upload-workflow-container';
